import { Link } from 'react-router-dom';
import type { InvoiceStrip } from '../../shared/invoicing';

export function ProjectInvoiceAction({ action, onDraft, busy = false, mobile = false, primary = false }: {
  action: InvoiceStrip['action']; onDraft: () => void; busy?: boolean; mobile?: boolean; primary?: boolean;
}) {
  if (!action) return null;
  const cls = mobile ? 'cbtn' : `btn${primary ? ' primary' : ''}`;
  return action.type === 'open'
    ? <Link className={cls} to={`/finance/invoices/${action.id}`}>Open invoice →</Link>
    : <button className={cls} type="button" disabled={busy} onClick={onDraft}>{busy ? 'Loading…' : 'Draft invoice →'}</button>;
}
